import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=24d39685&"
import script from "./TOS.ts?vue&type=script&lang=ts&"
export * from "./TOS.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports